import {Component, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AdxPaymentDetailsModalComponent} from 'src/app/adx-payment/components/adx-payment-details-modal/adx-payment-details-modal.component';
import {GridEventOutput, GridModel} from 'src/app/shared/model/page-grid';
import {AdxPaymentModel, AdxPaymentResponse} from '../../models/adx-payment';
import {PaymentStepperFormComponent} from '../payment-stepper-form/payment-stepper-form.component';
import {PageGridComponent} from 'src/app/shared/components/page-grid/page-grid.component';
import {generatePaymentGrid} from '../../constants/payments-grid';
import {AdxPaymentService} from '../../service/adx-payment.service';
import {Subscription} from 'rxjs';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@Component({
    selector: 'app-payments-received-grid',
    templateUrl: './payments-received-grid.component.html',
    standalone: false
})
@AutoUnsubscribe()
export class PaymentsReceivedGridComponent implements OnInit, OnDestroy {
  
  @ViewChild(PageGridComponent) protected paymentsReceivedGridRef?: PageGridComponent;

  private dialog = inject(MatDialog);
  private adxPaymentService = inject(AdxPaymentService);
  private refreshGridSubscription$?: Subscription;

  protected paymentsReceivedGrid: GridModel<AdxPaymentResponse> = {
    ...generatePaymentGrid(),
    gridDataTestId: 'payments-received-list',
    gridTitle: 'Payments Received',
    filtersInitial: { payTypeId: 1 },
  };

  ngOnInit(): void {
    this.refreshGridSubscription$ = this.adxPaymentService.refreshAdxPaymentGrid$.subscribe(() => {
      if (this.paymentsReceivedGridRef) {
        this.paymentsReceivedGridRef.getItems();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.refreshGridSubscription$) {
      this.refreshGridSubscription$.unsubscribe();
    }
  }

  public openDialog({item, column}: GridEventOutput<AdxPaymentModel>): void {
    if(column === 'fmsAdxPaymentDetailId') {
      this.openDetailsModal(item, 'Payment Information');
    }
  }

  protected openCreatePaymentDialog(): void {
    this.dialog.open(PaymentStepperFormComponent).afterClosed().subscribe((saved)=>{
      if(saved){
        this.paymentsReceivedGridRef?.getItems();
      }
    });
  }

  private openDetailsModal(adxPayment: AdxPaymentModel, title: string): void {
    this.dialog.open(AdxPaymentDetailsModalComponent, {
      width: '55%',
      data: { adxPaymentId: adxPayment.fmsAdxPaymentDetailId, title: title }
    });
  }
}
